import { NotificationType, OrderType } from "./ApiTransport"; 
import { PaymentType } from "./ApiTransport"; 
import { OrderInitiator } from "./ApiTransport"; 
import { OrderBalanceType } from "./ApiTransport"; 
import { SubscriptionStatus } from "./ApiTransport"; 
import { VehicleLinkType } from "./ApiTransport"; 
import { StaffRole } from "./ApiTransport"; 
import { SearchEntityType } from "./ApiTransport"; 
import { AccessKeyLinkType } from "./ApiTransport"; 
import { BalanceChangeType } from "./ApiTransport"; 
import { SessionType } from "./ApiTransport"; import { Duration, LocalDateTime, LocalTime, LocalDate, Instant } from "@js-joda/core";
import { Money } from "./Money";
import { PaymentReportFilter, SubscriptionReportFilter } from "./Api";
import { ServerTransferConnectedAccountDropdown } from "../shared/api/axios-client";

export interface Operator {
    operatorId: number;
    name: string;
    address: UsAddress;
    emailAddress: string;
    phoneNumber: string;
    website: string;
    logoUrl: string;
    topTitle: string;
    topText: string;
    bottomLeftTitle: string;
    bottomLeftText: string;
    bottomRightTitle: string;
    bottomRightText: string;
}

export interface FacilityInfo {
    facilityId: number;
    operatorId: number;
    name: string;
    description: string;
    timeZone: string;
    address: UsAddress;
    coordinates: Coordinates;
    listImageId: number | null;
    entryInstructions: string;
    phoneNumber: string;
    emailAddress: string;
    clearanceInches: number;
    hasIntegrationsEnabled: boolean;
    features: string[];
}

export interface UsAddress {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipCode: string;
    latitude?: number;
    longitude?: number;
    timezone?: string;
}

export interface Coordinates {
    lat: number;
    lng: number;
}

export interface OrderDebt {
    orderId: number;
    createdWhen: Instant;
    orderTotal: Money;
    paid: Money;
    unpaid: Money;
}

export interface Vehicle {
    vehicleId: number;
    make: string;
    model: string;
    color: string;
    stateCode: string;
    licensePlateNumber: string;
}

export interface RateProgram {
    rateProgramId: number;
    facilityId: number;
    name: string;
    start: LocalDateTime;
    end: LocalDateTime | null;
    inAfter: LocalTime | null;
    inBefore: LocalTime | null;
    outAfter: LocalTime | null;
    outBefore: LocalTime | null;
    applicableDays: number | null;
    isEvent: boolean;
    entries: RateEntry[];
    isActive: boolean;
    isValidation: boolean;
    canBeValidated: boolean;
    validationType: ValidationType;
    encodedRateProgramId: string;
    isSpecialRate: boolean;
}

export interface RateProgramDropdown {
    id: number;
    name: string;
}

export interface FormattedAuditEntry {
  entityType?: string | null;
  entityId?: string | null;
  changeType?: string | null;
  eventName: string; 
  changedBy?: string | null;
  timestamp: Date | null;

  oldValues: any;
  newValues: any;

  rawOldValues?: string | null;
  rawNewValues?: string | null;
}

export interface AuditChange {
  field: string;
  oldValue: any;
  newValue: any;
}

export interface NormalizedAuditEntry {
  entityType: string;
  entityId: string;
  changeType: string;
  eventName: string;
  changedBy: string;
  timestamp: string;
  oldValues: Record<string, any> | null;
  newValues: Record<string, any> | null;
  changes: AuditChange[];
}

export enum RateType {
  Hourly = 0,
  Event = 1,
  Validation = 2,
  Override = 3
}

export interface RateEntry {
    rateEntryId: number;
    rateProgramId: number;
    upTo: Duration;
    rate: Money;
}

export interface FacilityImage {
    facilityImageId: number;
    storedImageId: number;
    orderId: number;
    caption: string;
    altText: string;
}

export interface ListedPlan {
    planId: number;
    planEntryId: number;
    name: string;
    description: string;
    accessHours: string;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
    price: Money;
}

export interface Order {
    orderId: number;
    initiator: OrderInitiator;
    initiatedByStaffId: number | null;
    parkerId: number;
    facilityId: number;
    price: Money;
    createdWhen: Instant;
    processorPaymentIntentKey: string | null;
    type: OrderType;
    facility: FacilityInfo;
    submittedWhen: Instant | null;
    balance: OrderBalance;
    summary: string;
}

export interface OrderDetails {
    order: Order;
    balanceChanges: OrderBalance[];
    summary: string;
}

export interface OrderBalance {
    orderBalanceId: number;
    type: OrderBalanceType;
    orderId: number;
    createdWhen: Instant;
    debt: Money;
    paid: Money;
    balance: Money;
    totalDebt: Money;
    totalPaid: Money;
    reason: string | null;
    paymentId: number | null;
}

export interface Invoice {
    invoiceId: number;
    invoiceNumber: string;
    createdWhen: Instant;
    dueWhen: LocalDate;
    openingBalance: Money;
    amountDue: Money;
    endingBalance: Money;
    emailSentWhen: Instant | null;
    facility: FacilityInfo;
    orders: OrderInfo[];
    parker: ParkerInfo;
}

export interface Payment {
    paymentId: number;
    parentPaymentId: number | null;
    facilityId: number;
    facility: FacilityLite;
    type: PaymentType;
    amount: Money;
    remaining: Money;
    unapplied: Money;
    paymentMethod: string;
    paymentIntentKey: string | null;
    chargeKey: string | null;
    paymentKey: string | null;
    changes: PaymentChange[];
    applications: ApplyPayment[];
    createdWhen: Instant;
    paidWhen: Instant;
    status: string;
    checkDate?: LocalDate;
    checkNumber?: string;
    checkMemo?: string;
    staffName?: string;
    creditNote?: string;
}

export interface ApplyPayment {
    orderBalanceId: number;
    type: OrderBalanceType;
    facilityId: number;
    parkerId: number;
    orderId: number;
    debt: Money;
    paid: Money;
    balance: Money;
    totalDebt: Money;
    totalPaid: Money;
    createdWhen: Instant;
    invoiceNum?:string;
    invoiceId?:number;
}

export interface OrderInfo {
    orderId: number;
    initiator: OrderInitiator;
    initiatedByStaffId: number | null;
    parkerId: number;
    facilityId: number;
    price: Money;
    createdWhen: Instant;
    processorPaymentIntentKey: string | null;
    orderType: OrderType;
    submittedWhen: Instant | null;
    balance: OrderBalance;
    summary: string;
}

export interface PaymentChange {
    paymentId: number;
    parentPaymentId: number | null;
    facilityId: number;
    parkerId: number;
    type: PaymentType;
    amount: Money;
    balance: Money;
    createdWhen: Instant;
}

export interface LogInReq {
    emailAddress: string;
    password: string;
}

export interface ChangeNameReq {
    name: string;
}

export interface ChangePhoneReq {
    phoneNumber: string;
}

export interface StripeLinkResp {
    isOnboarded: boolean;
    connectLink: string | null;
}

export interface ChangePasswordReq {
    currentPassword: string;
    newPassword: string;
}

export interface ForgotPasswordReq {
    emailAddress: string;
}

export interface Staff {
    staffId: number;
    role: StaffRole;
    roles: Array<string>;
    operatorId: number;
    name: string;
    note: string;
    emailAddress: string;
    phoneNumber: string;
    createdWhen: Instant;
    removedWhen: Instant | null;
}

export interface OperatorInvoice {
  invoiceNumber: string;
  facilityName?: string | null;
  amountDue: number; 
  status: OperatorInvoiceStatus;
  dueDate: string; 
  createdDate: string;
  paymentUrl?: string;
  id?: string | number;
}

export enum OperatorInvoiceStatus {
  Draft,
  Open,
  Paid ,
  Overdue,
  Canceled
}

export interface StaffNotification {
    staffNotificationId: number;
    staffId: number;
    notificationType: NotificationType,
    createdWhen: Instant;
}

export interface StaffNotificationUpdateReq {
    notificationType: NotificationType,
    enable: boolean;
}

export interface StaffUpdateReq {
    name: string;
    emailAddress: string;
    phoneNumber: string;
    note: string;
}

export interface InviteStaffReq {
    role: StaffRole;
    name: string;
    emailAddress: string;
    phoneNumber: string;
    password: string;
    note: string;
}

export interface SearchResult {
    searchResultId: number;
    type: SearchEntityType;
    id: number;
    name: string;
    facilityName: string;
    facilityId: number;
}

export interface PlanCreateReq {
    facilityId: number;
    name: string;
    accessHours: string;
    description: string;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
    initialPrice: number;
    terms: string;
    isPrivate: boolean;
}

export interface PlanUpdateReq {
    planEntryId: number;
    name: string;
    description: string;
    accessHours: string;
    planPriceId: number | null;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
    note: string;
    terms: string;
}

export interface PlanPriceAddReq {
    name: string;
    price: Money;
    couponCode: string;
}

export interface ParkerImportReq {
    file: File;
}

export interface PlanPriceListResp {
    planPriceId: number;
    name: string;
    price: number;
    couponCode: string;
}

export interface PlanPriceEditResp {
    planPriceId: number;
    name: string;
    price: Money;
}

export interface Reservation {
    reservationId: number;
    facilityId: number;
    parkerId: number;
    start: LocalDateTime;
    end: LocalDateTime;
    actualStart: Instant;
    actualEnd: Instant;
    duration: Duration;
    rateProgramId: number;
    price: Money;
    createdWhen: Instant;
    rateProgram: RateProgramInfo;
    validationRequestId?: number;
    confirmationNum: string;
    spaces: string;
}

export interface Subscription {
    subscriptionId: number;
    parkerId: number;
    status: SubscriptionStatus;
    start: LocalDate;
    facility: FacilityInfo;
    accessPeriods: AccessPeriodInfo[];
    parkers: SubscriptionParker[];
    vehicles: Vehicle[];
    paymentMethod: string | null;
    prices: PlanPriceListResp[];
    planEntryId: number;
    planPriceId: number;
    quantity: number;
    end: LocalDate | null;
    isAccountsReceivable: boolean;
    price: Money;
    plan: PlanInfo;
    isEnhancedGroup: boolean;
}

export interface PlanInfo {
    planId: number;
    facilityId: number;
    name: string;
    description: string;
    accessHours: string;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
}

export interface Facility {
    facilityId: number;
    name: string;
    description: string;
    timeZone: string;
    address: UsAddress;
    coordinates: Coordinates;
    listImageId: number | null;
    entryInstructions: string;
    physicalCapacity: number;
    enforcedCapacity: number;
    clearanceInches: number;
    website: string;
    emailAddress: string;
    phoneNumber: string;
    images: FacilityImage[];
    hourlyRates: RateProgram[];
    listedPlans: ListedPlan[];
    timezone: string;
    features: string[];
    payoutAccount: ServerTransferConnectedAccountDropdown;
}

export interface FacilityLite {
    facilityId: number;
    name: string;
    description: string;
    timeZone: string; //just the time zone codes supported in America
    address: UsAddress;
    coordinates: Coordinates;
    listImageId: number | null;
    entryInstructions: string;
    physicalCapacity: number;
    enforcedCapacity: number;
    clearanceInches: number;
    website: string;
    emailAddress: string;
    phoneNumber: string;
}

export interface Parker {
    parkerId: number;
    name: string;
    emailAddress: string;
    phoneNumber: string | null;
    note: string;
}

export interface ParkerListEntry {
    parkerId: number;
    name: string;
    emailAddress: string;
    phoneNumber: string | null;
    note: string;
    balance: Money;
    monthly: Money;
}

export interface ParkerDetails {
    parkerId: number;
    name: string;
    note: string;
    emailAddress: string;
    phoneNumber: string | null;
    balance: Money;
    subscriptions: ParkerSubInfo[];
    reservations: Reservation[];
    vehicles: Vehicle[];
    subscriptionParkerId: number | null;
    staffRole: StaffRole
    nonRenewedSubscriptionIds: number[];
}

export interface ParkerDetailsGridResult {
    parkerDetailsGrid: ParkerDetailsGrid[];
    timeZone: string;
}

export interface ParkerDetailsGrid {
    parkerId: number;
    name: string;
    note: string;
    emailAddress: string;
    phoneNumber: string | null;
    balance: Money;
    status: SubscriptionStatus;
    mrr: Money;
    guestCount: number;
    spotCount: number;
    planCount: number;
    createdWhen: Instant;
    planName: string;
    unitPrice: Money;
    subscriptionId: number;
    isExpired: boolean;
    isActive: boolean;
    inviteId: number;
    hasAutoPay: boolean;
    hasNonRenewedPeriod: boolean;
}

export interface CheckCreateReq {
    checkDate: LocalDate;
    checkNumber: string;
    checkMemo: string;
    amount: Money;
}

export interface PmtApply {
    orderId: number;
    amount: Money;
}

export interface Plan {
    planId: number;
    planEntryId: number;
    name: string;
    description: string;
    accessHours: string;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
    planPriceId: number | null;
    planPrice: PlanPriceInfo | null;
    prices: PlanPriceDetails[];
    note: string;
    isPrivate: boolean;
    isOneTermPlan: boolean;
    prorate: string | null;
    terms:string;
    approvalEmailText: string;
    renewalFailureDeactivateAfterDays: number;
}

export interface PlanDetails {
    planId: number;
    planEntryId: number;
    name: string;
    description: string;
    accessHours: string;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
    planPriceId: number | null;
    approvalEmailText: string;
    terms: string;
    isPrivate: boolean;
    planPrice: PlanPriceInfo | null;
    prices: PlanPriceDetails[];
    history: PlanChange[];
    prorate: string | null;
    renewalFailureDeactivateAfterDays: number;
}

export interface PlanChange {
    planEntryId: number;
    planId: number;
    name: string;
    description: string;
    accessHours: string;
    dayOfMonthInvoice: number;
    dayOfMonthDue: number;
    dayOfMonthLate: number;
    planPriceId: number | null;
    planPrice: PlanPriceInfo | null;
    createdWhen: Instant;
    createdByStaffId: number;
    note: string;
}

export interface PlanPriceInfo {
    planPriceId: number;
    planId: number;
    name: string;
    price: Money;
    createdByStaffId: number;
    createdWhen: Instant;
}

export interface PlanPriceDetails {
    planPriceId: number;
    planId: number;
    name: string;
    price: Money;
    createdByStaffId: number;
    createdWhen: Instant;
    subscribers: SubscriberInfo[];
    couponCode: string;
}

export interface InviteParkerReq {
    name: string;
    emailAddress: string;
    phoneNumber: string | null;
    planId: number;
    planPriceId: number;
    quantity: number;
    message: string;
    requirePayment: boolean;
    startDate: LocalDate;
    IsEnhancedGroup: boolean;
}

export interface FacilityCreateReq {
    name: string;
    address: UsAddress;
    description: string;
    instructions: string;
    postedCapacity: number;
    enforcedCapacity: number;
    website: string;
    emailAddress: string;
    phoneNumber: string;
    clearanceInches: number;
    imageThumb: string;
    bannerImage: string;
    latitude: number;
    longitude: number;
    timezone: string;
}

export interface FacilityUpdateReq {
    facilityId: number;
    name: string;
    address: UsAddress;
    description: string;
    instructions: string;
    postedCapacity: number;
    enforcedCapacity: number;
    clearanceInches: number;
    website: string;
    emailAddress: string;
    phoneNumber: string;
    latitude: number;
    longitude: number;
    timezone: string;
}

export interface PaymentSavedReports {
    savedReportId: number;
    name: string;
    filter: PaymentReportFilter;
}

export interface SubscriptionSavedReports {
    savedReportId: number;
    name: string;
    filter: SubscriptionReportFilter;
}

export interface ParkerAgingRecord {
    name: string;
    emailAddress: string;
    balance30Days: number;
    balance60Days: number;
    balance90Days: number;
    totalBalance: number;
}

export interface ParkerInfo {
    parkerId: number;
    operatorId: number;
    name: string;
    emailAddress: string;
    phoneNumber: string | null;
    createdWhen: Instant;
    vehicles: Vehicle[];
    isManaged: boolean;
}

export interface RateProgramData {
    facilityId: number;
    name: string;
    start: LocalDateTime;
    end: LocalDateTime | null;
    inAfter: LocalTime | null;
    inBefore: LocalTime | null;
    outAfter: LocalTime | null;
    outBefore: LocalTime | null;
    isEvent: boolean;
    isValidation: boolean;
    applicableDays: number | null;
    entries: RateEntryData[];
    canBeValidated: boolean;
    validationType: ValidationType;
    isSpecialRate: boolean;
}

export enum ValidationType {
    Fixed,
    Discount
}

export interface RateProgramInfo {
    rateProgramId: number;
    facilityId: number;
    name: string;
    start: LocalDateTime;
    end: LocalDateTime | null;
    inAfter: LocalTime | null;
    inBefore: LocalTime | null;
    outAfter: LocalTime | null;
    outBefore: LocalTime | null;
    isEvent: boolean;
}

export interface RateEntryData {
    upTo: Duration;
    rate: Money;
}

export interface SubscriberInfo {
    parkerId: number;
    name: string;
    note: string;
    emailAddress: string;
    phoneNumber: string | null;
    quantity: number;
}

export interface SubscriptionUpdateReq {
    subscriptionEntryId: number;
    subscriptionId: number;
    planPriceId: number;
    quantity: number;
    status: SubscriptionStatus;
    start: LocalDate;
    end: LocalDate | null;
    isAccountsReceivable: boolean;
    isLateFeeEnabled: boolean;
    applyQuantityChangeNow: boolean;
}

export interface SubEntry {
    subscriptionEntryId: number;
    subscriptionId: number;
    planId: number;
    planEntryId: number;
    planPriceId: number;
    quantity: number;
    status: SubscriptionStatus;
    start: LocalDate;
    end: LocalDate | null;
    isAccountsReceivable: boolean;
    isLateFeeEnabled: boolean;
    createdWhen: Instant;
}

export interface SubEntryForEdit {
    prices: PlanPriceInfo[];
    subscriptionEntryId: number;
    subscriptionId: number;
    planId: number;
    planEntryId: number;
    planPriceId: number;
    quantity: number;
    status: SubscriptionStatus;
    start: LocalDate;
    end: LocalDate | null;
    isAccountsReceivable: boolean;
    isLateFeeEnabled: boolean;
    createdWhen: Instant;
    applyQuantityChangeNow: boolean | undefined;
}

export interface AccessPeriodInfo {
    accessPeriodId: number;
    subscriptionEntryId: number;
    quantity: number;
    start: LocalDate;
    end: LocalDate;
    isDelivered: boolean;
    price: Money;
}

export interface SubscriptionParker {
    parker: ParkerInfo;
    quantity: number;
    vehicles: Vehicle[];
    subscriptionGroupId?: number;
    subscriptionGroupName: string;
    startDate: Instant | null;
}

export interface ParkerUpdateReq {
    name: string;
    emailAddress: string;
    phoneNumber: string | null;
    note: string;
}

export interface SubListEntry {
    subscriptionId: number;
    parkerId: number;
    status: SubscriptionStatus;
    quantity: number;
    unitPrice: number | null;
    price: number | null;
    plan: PlanInfoBasic;
    facility: FacilityInfo;
}

export interface PlanInfoBasic {
    planId: number;
    planEntryId: number;
    name: string;
    accessHours: string;
}

export interface FacilitySub {
    subscriptionId: number;
    parkerId: number;
    status: SubscriptionStatus;
    quantity: number;
    unitPrice: Money;
    price: Money;
    createdWhen: Instant;
    parker: ParkerInfo;
    plan: PlanInfoBasic;
    facility: FacilityInfo;
}

export interface FacilitySubByParker {
    subscriptionId: number;
    parkerId: number;
    status: SubscriptionStatus;
    quantity: number;
    unitPrice: number;
    price: number;
    createdWhen: Instant;
    parker: ParkerInfo;
    plan: PlanInfoBasic;
    facility: FacilityInfo;
}

export interface DeleteConfirm {
    deleteCode: string;
}

export interface ChangeEmailReq {
    currentPassword: string;
    newEmailAddress: string;
}

export interface VehicleDetails {
    vehicleId: number;
    make: string;
    model: string;
    color: string;
    stateCode: string;
    licensePlateNumber: string;
    links: VehicleLink[];
}

export interface VehicleLink {
    type: VehicleLinkType;
    reservationId: number | null;
    subscriptionId: number | null;
    reservation: Reservation | null;
    subscription: SubListEntry | null;
}

export interface FacilityInvoice {
    invoiceId: number;
    invoiceNumber: string;
    createdWhen: Instant;
    dueWhen: LocalDate;
    openingBalance: Money;
    amountDue: Money;
    endingBalance: Money;
    emailSentWhen: Instant | null;
    orders: OrderInfo[];
    parker: ParkerInfo;
}

export interface ResetCodeCheckReq {
    resetPasswordCode: string;
}

export interface ResetPasswordReq {
    resetPasswordCode: string;
    newPassword: string;
}

export interface AccessKey {
    accessKeyId: number;
    facilityId: number;
    accessKeyNumber: string;
    createdWhen: Instant;
    createdByStaff: Staff;
    note: string;
    facility: FacilityInfo;
    links: AccessKeyLinkInfo[];
}

export interface AccessKeyListEntry {
    accessKeyId: number;
    accessKeyNumber: string;
    createdWhen: Instant;
    note: string;
}

export interface AccessKeyLinkInfo {
    accessKeyLinkId: number;
    accessKeyId: number;
    type: AccessKeyLinkType;
    createdWhen: Instant;
    note: string;
    subscription: SubscriptionInfo | null;
    guest: SubscriptionParkerAccessKey | null;
    vehicle: SubscriptionParkerVehicleAccessKey | null;
}

export interface SubscriptionInfo {
    subscriptionId: number;
    status: SubscriptionStatus;
    start: LocalDate;
    parker: ParkerInfo;
}

export interface AccessKeyReq {
    accessKeyNumber: string;
    note: string;
}

export interface AccessKeyAssignSub {
    accessKeyId: number;
    subscriptionId: number;
    note: string | null;
}

export interface AccessKeyParkerAssignReq {
    accessKeyId: number;
    subscriptionParkerId: number;
    note: string | null;
}

export interface AccessKeyVehicleSubAssignReq {
    accessKeyId: number;
    vehicleSubscriptionId: number;
    note: string | null;
}

export interface SubscriptionParkerAccessKey {
    subscription: SubscriptionInfo;
    parker: ParkerInfo;
}

export interface SubscriptionParkerVehicleAccessKey {
    isPrimary: boolean;
    subscription: SubscriptionInfo;
    parker: ParkerInfo;
    vehicle: Vehicle;
}

export interface FacilityStats {
    totalMonthlyParkerCount: number;    
    monthlyRecurringRevenue: number;
    currentMonthTransientRevenue: number;
    totalUnpaidBalance: number;
    pendingParkers: number;
    activeReservations: number;
    upcomingReservations: number;
}

export interface SubscriptionStat {
    status: SubscriptionStatus;
    start: LocalDate;
    end: LocalDate | null;
    qty: number;
    unit: Money;
    total: Money;
}

export interface ReservationStat {
    start: Instant;
    end: Instant;
    price: Money;
}

export interface OrderStat {
    created: Instant;
    price: Money;
    type: OrderType;
    isPaid: boolean;
}

export interface ParkerSubInfo {
    subscriptionId: number;
    parkerId: number;
    status: SubscriptionStatus;
    quantity: number;
    unitPrice: Money;
    price: Money;
    createdWhen: Instant;
    guests: SubscriptionParker[];
    plan: PlanInfoBasic;
    hasAutoBillingEnabled: boolean;
    facilityHasIntegrationsEnabled: boolean;
}

export interface FacilityPayment {
    paymentId: number;
    parentPaymentId: number | null;
    type: PaymentType;
    amount: Money;
    balance: Money;
    remaining: Money;
    paymentMethod: string;
    paymentIntentKey: string | null;
    chargeKey: string | null;
    createdWhen: Instant;
    parker: ParkerInfo;
    changes: PaymentChange[];
    applications: ApplyPayment[];
}

export interface BalanceChange {
    number: number;
    type: BalanceChangeType;
    paidWhen: Instant;
    payment: Payment | null;
    orderBalance: OrderBalance | null;
    invoice: InvoiceInfo | null;
    rank: number;
    balance: Money;
}

export interface ImportPaymentReq {
    note: string;
    amount: Money;
}

export interface Session {
    parker: ParkerInfo;
    type: SessionType;
    subscription: SessionSubscription | null;
    subscriptionGuest: SessionSubscription | null;
    reservation: Reservation | null;
    vehicles: string;
}

export interface SessionSubscription {
    subscriptionId: number;
    parkerId: number;
    status: SubscriptionStatus;
    guests: SubscriptionParker[];
    plan: PlanInfoBasic;
    accessPeriods: SessionAccessPeriod[];
}

export interface SessionAccessPeriod {
    subscriptionId: number;
    parkerId: number;
    quantity: number;
    price: Money;
    createdWhen: Instant;
    guests: SubscriptionParker[];
    plan: PlanInfoBasic;
    orderBalance: OrderBalance;
}

export interface PlanInvoiceReq {
    year: number;
    month: number;
}

export interface PlanInvoiceResp {
    invoice: InvoiceInfo;
    emailArgs: InvoiceArgs;
}

export interface InvoiceInfo {
    invoiceId: number;
    invoiceNumber: string;
    orderId: number;
    createdWhen: Instant;
    dueWhen: LocalDate;
    openingBalance: Money;
    amountDue: Money;
    endingBalance: Money;
    emailSentWhen: Instant | null;
    parker: ParkerInfo;
}

export interface InvoiceArgs {
    facilityName: string;
    parkerName: string;
    invoiceId: string;
    invoiceDate: string;
    accessPeriodStart: string;
    accessPeriodEnd: string;
    openingBalance: string;
    orderDesc: string;
    orderPrice: string;
    totalDue: string;
    staffName: string;
    staffEmail: string;
    link: string;
    linkText: string;
    operator: Operator | null;
}

export interface SubscriptionParkerInviteReq {
    subscriptionId: number;
    quantity: number;
    name: string;
    emailAddress: string;
    isLoginEnabled: boolean;
    subscriptionGroupId: number | null;
    startDate?: string;
}

export interface SubscriptionParkerChangeReq {
    parkerId: number;
    quantity: number;
}

export interface SubscriptionParkerRemoveReq {
    parkerId: number;
}

export interface VehicleAddReq {
    vehicleId: number;
}

export interface VehicleDeleteReq {
    vehicleId: number;
}

export interface VehicleLinkResp {
    vehicleLinkId: number;
    vehicleId: number;
    type: VehicleLinkType;
    subscriptionId: number;
}

export interface OrderCustomReq {
    name: string;
    emailAddress: string;
    phoneNumber: string | null;
    description: string;
    items: OrderCustomItemReq[];
    dueDate: LocalDate;
}

export interface OrderCustomItemReq {
    category: string | null;
    name: string;
    unitPrice: number;
    quantity: number;
}

export interface FacilityPayout {
    payoutId: number;
    facilityId: number;
    payoutKey: string;
    amount: Money;
    createdWhen: Instant;
    processorCreatedWhen: Instant;
    arrivalWhen: Instant;
    transactions: PayoutTransaction[];
}

export interface PayoutTransaction {
    payoutTransactionId: number;
    payoutId: number;
    balanceTransactionKey: string;
    type: string;
    key: string;
    paymentIntentKey: string | null;
    chargeKey: string | null;
    refundKey: string | null;
    disputeKey: string | null;
    payment: PayoutTransactionPayment | null;
    gross: Money;
    fee: Money;
    net: Money;
    createdWhen: Instant;
    processorCreatedWhen: Instant;
    availableWhen: Instant;
}

export interface PayoutTransactionPayment {
    paymentId: number;
    parentPaymentId: number | null;
    type: PaymentType;
    amount: Money;
    balance: Money;
    createdWhen: Instant;
    parker: ParkerInfo;
    applications: ApplyPayment[];
}

export interface OrderAdjustReq {
    orderId: number;
    currentTotalDebt: Money;
    newTotalDebt: Money;
    reason: string;
}

export interface PaymentAdjustReq {
    paymentId: number;
    currentAmount: Money;
    newAmount: Money;
    note: string;
}

export interface PlanBillInitResp {
    parker: ParkerInfo;
    order: OrderInfo;
}

export interface PlanBillConfirmResp {
    parker: ParkerInfo;
    order: OrderInfo;
    success: boolean;
    amountPaid: Money;
    error: string;
}

export interface PaymentReport {
    parkerId: number;
    operatorId: number;
    facilityId: number;
    facilityName: string;
    name: string;
    emailAddress: string;
    paymentId: number;
    orderId: number;
    totalPaid: Money;
    facilityFees: Money;
    reversed: Money;
    remittedToFacility: Money;
    paidWhen: Instant;
    paymentType: string;
    orderType: string;
    status: string;
    paymentIntentKey: string;
    timeZone: string;
    payoutWhen: Instant;
    reversedWhen: Instant;
    reversedReason: string;
}

export interface SubscriptionReport {
    parkerId: number;
    operatorId: number;
    facilityId: number;
    facilityName: string;
    name: string;
    emailAddress: string;
    facility: string;
    start: Instant;
    end: Instant;
    quantity: number;
    plan: string;
    accessPeriodId: number;
    planId: number;
    planEntryId: number;
    subscriptionId: number;
    timeZone: string;
    status: string;
    expireDate: Instant | null;
    allLps: string;
    linkedLps: string;
}

export interface PagedResult<T> {
    total: number;
    page: number;
    pageSize: number;
    items: T[];
}

// Types
export interface PaymentReportApiResponse {
    parkerId: number;
    operatorId: number;
    facilityId: number;
    facilityName: string;
    name: string;
    emailAddress: string;
    paymentId: number;
    orderId: number;
    totalPaid: number; // cents
    facilityFees: number; // cents
    reversed: number; // cents
    remittedToFacility: number; // cents
    paidWhen: Instant;
    paymentType: string;
    orderType: string;
    status: string;
    paymentIntentKey: string;
    timeZone: string;
    payoutWhen: Instant;
    reversedReason: string;
    reversedWhen: Instant;
}

export interface PaymentReport {
    parkerId: number;
    operatorId: number;
    facilityId: number;
    facilityName: string;
    name: string;
    emailAddress: string;
    paymentId: number;
    orderId: number;
    totalPaid: Money;
    facilityFees: Money;
    reversed: Money;
    remittedToFacility: Money;
    paidWhen: Instant;
    paymentType: string;
    orderType: string;
    status: string;
    paymentIntentKey: string;
    timeZone: string;
}

export interface SubscriptionReport {
    parkerId: number;
    operatorId: number;
    facilityId: number;
    facilityName: string;
    name: string;
    emailAddress: string;
    facility: string;
    start: Instant;
    end: Instant;
    quantity: number;
    plan: string;
    accessPeriodId: number;
    planId: number;
    planEntryId: number;
    subscriptionId: number;
    timeZone: string;
    status: string;
    expireDate: Instant | null;
    allLps: string;
    linkedLps: string;
}

export interface FilterFormData {
    email?: string;
    name?: string;
    from: string;
    to: string;
    payoutFrom?: string;
    payoutTo?: string;
    planName?: string;
    paymentType?: string;
    paymentStatus?: string;
    status?: string;
    expireDate?: string;
    quickDateMode?: string;
    quickPayoutDateMode?: string;
    age?: string;
    validationId?: number;
    cutoffMode?: 
    | 'All'
    | 'Today'
    | 'LastMonth'
    | 'Custom';
    cutoffDate?: string;
}

